import React from 'react';
import ReactDOM from 'react-dom/client';
// Maersk Design System: fonts, design tokens and foundations (scoped to `.mds`, set on <body>)
import '@maersk-global/fonts/maeu/fonts-cdn.css';
import '@maersk-global/mds-design-tokens/maersk/light/css/design-tokens-px.css';
import '@maersk-global/mds-foundations/css/foundations.min.css';
import './index.css';
import App from './App';
import { msalInstance } from './auth/msalConfig';

msalInstance.initialize().then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
